import React from "react";
import { Link } from "react-router-dom";
import LogoSvgLight from "./LogoSvgLight";
import LogoSvg from "./LogoSvg";
import dsLogo from "../../images/logos/logo.png";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}
const token = localStorage.getItem("token");
const Logo: React.FC<LogoProps> = ({
  className = "lg:w-[130px] w-28 h-auto sm:pl-4 lg:pl-0 z-10",
}) => {
  const token = localStorage.getItem("token");
  const redirectPath = token ? "/" : "/login"; // Redirect based on token
  return (
    
      <Link to={redirectPath} className={`ttnc-logo inline-block ${className}`}>
        <img src={dsLogo} alt="direktStays logo" />
      </Link>
  );
};

export default Logo;
